export enum Port {
  DASH_SYSTEMS_PORT = 5173,
  RBAC_EDITOR = 5174,
}
